import { render, staticRenderFns } from "./ViewsEditModal.vue?vue&type=template&id=8bb2273a&scoped=true"
import script from "./ViewsEditModal.vue?vue&type=script&lang=ts"
export * from "./ViewsEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb2273a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bb2273a')) {
      api.createRecord('8bb2273a', component.options)
    } else {
      api.reload('8bb2273a', component.options)
    }
    module.hot.accept("./ViewsEditModal.vue?vue&type=template&id=8bb2273a&scoped=true", function () {
      api.rerender('8bb2273a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/price-lists/ViewsEditModal.vue"
export default component.exports